import { Component } from '@angular/core';

@Component({
  selector: 'prime-platform-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
})
export class LogoutComponent {}
